import { Box, Button, IconButton, Typography } from "@mui/material";
import React from "react";
import ProjectDetails from "../ProjectDetails/ProjectDetails.jsx";
import CloseIcon from "@mui/icons-material/Close";
import { useMediaQuery } from "@mui/material";
import MobileProjectDetails from "../ProjectDetails/MobileProjectDetails.jsx";
const River = ({ whiteBandOpen, resetWhiteBand, displayInfos }) => {
    const isMobile = useMediaQuery('(max-width:800px)');

    const calculateHeight = () => {
        if (isMobile) {
            if (whiteBandOpen)
                return "100dvh";
            else if (!whiteBandOpen) {
                return "5dvh"
            }
        }
        else {
            return "100vh";
        }
    }

    const calculateWidth = () => {
        if (!isMobile) {
            if (whiteBandOpen)
                return "100vw";
            else if (!whiteBandOpen) {
                return "100px"
            }
        }
        else {
            return "100dvw";
        }
    }

    return (
        <>
            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: calculateHeight(),
                    backgroundColor: "white",
                    width: calculateWidth(),
                    transition: `${isMobile ? "height" : "width"} 0.7s ease-in-out ${!whiteBandOpen ? "0.6s" : ""}`, // Smooth transition for expanding
                    display: "flex",
                    justifyContent: isMobile ? "space-around" : "flex-end", // Push the content to the bottom
                    alignItems: isMobile ? "start" : "flex-end", // Align content to the right
                }}
            >
                <Box sx={{
                    position: "fixed",
                    display: "flex",
                    flexDirection: isMobile ? "row" : "column-reverse",
                    width: isMobile ? "100%" : "100px",
                    height: isMobile ? "unset" : "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "white"
                }}>

                    <Box
                        component="img"
                        onClick={resetWhiteBand}
                        sx={{
                            top: isMobile ? "-20px" : "none",
                            cursor: "pointer",
                            width: isMobile ? "200px" : "auto", // Adjust the size of the GIF
                            height: isMobile ? "5dvh" : "100px",
                            objectFit: isMobile ? "inherit" : "cover",
                            paddingBottom: isMobile ? "0px" : "20px"
                        }}
                        alt="Logo GIF"
                        src={isMobile ? `${process.env.PUBLIC_URL}/TTG_STUDIO_BLEU.svg` : `${process.env.PUBLIC_URL}/runner-2.gif`} // Path to your GIF
                    />
                    {whiteBandOpen &&
                        <IconButton
                            onClick={resetWhiteBand}
                            sx={{
                                position: "fixed",
                                right: isMobile ? "2dvw" : "50px",
                                top: isMobile ? "9.5dvh" : "50px",
                            }}>
                            <CloseIcon />
                        </IconButton>
                    }
                </Box>
                <Box
                    sx={{
                        width: "100%",
                        opacity: whiteBandOpen ? "1" : "0",
                        visibility: whiteBandOpen ? "visible" : "hidden", // Prevent interactions
                        transition: `opacity 0.7s ease-in-out ${whiteBandOpen ? "0.65s" : ""}, visibility 1s ease-in-out ${whiteBandOpen ? "0.65s" : ""}`, // Smooth transition
                    }}
                >
                    {isMobile ?
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100dvh", // Utilisez la hauteur de la fenêtre
                                overflowY: "auto", // Active le scrolling vertical
                            }}
                        >
                            <MobileProjectDetails />

                        </Box> :
                        <ProjectDetails />
                    }
                </Box>
            </Box >
        </>
    );
}

export default River;
